import React, { SVGProps } from 'react'
const SvgVirtualCardAndBudget = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={83}
    height={75}
    aria-hidden="true"
    {...props}
  >
    <defs>
      <filter
        id="VirtualCardAndBudget_svg__a"
        width="123.2%"
        height="122.9%"
        x="-11.6%"
        y="-10%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="VirtualCardAndBudget_svg__c"
        width="133.4%"
        height="133.3%"
        x="-16.7%"
        y="-16.6%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        id="VirtualCardAndBudget_svg__f"
        width="136.6%"
        height="137.9%"
        x="-18.3%"
        y="-15.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="VirtualCardAndBudget_svg__h"
        width="144.7%"
        height="144.7%"
        x="-26.4%"
        y="-14.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx={-1} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
      </filter>
      <filter
        id="VirtualCardAndBudget_svg__j"
        width="144%"
        height="166.7%"
        x="-22%"
        y="-27.3%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        id="VirtualCardAndBudget_svg__k"
        width="122%"
        height="133.3%"
        x="-11%"
        y="-10.6%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={1.5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
      </filter>
      <ellipse
        id="VirtualCardAndBudget_svg__b"
        cx={34.5}
        cy={35.5}
        rx={34.5}
        ry={35}
      />
      <ellipse
        id="VirtualCardAndBudget_svg__d"
        cx={23.798}
        cy={24.064}
        rx={23.792}
        ry={23.854}
      />
      <path
        id="VirtualCardAndBudget_svg__g"
        d="m29.001 44.344 1.607-26.41L3.252 27.96c2.182.103 5.503 2.399 9.964 6.886 4.349 4.375 9.61 7.54 15.785 9.497Z"
      />
      <path
        id="VirtualCardAndBudget_svg__i"
        d="m29.656 38.299-.032-24.568L5.051 13.7c.2 7.134 2.576 12.986 7.13 17.556 4.44 4.455 10.266 6.803 17.475 7.044Z"
      />
      <linearGradient
        id="VirtualCardAndBudget_svg__m"
        x1="25.184%"
        x2="78.542%"
        y1="50%"
        y2="50%"
      >
        <stop offset="0%" stopColor="#E4FFF9" />
        <stop offset="100%" stopColor="#FFF" />
      </linearGradient>
      <rect
        id="VirtualCardAndBudget_svg__l"
        width={50}
        height={33}
        x={0}
        y={0}
        rx={1.149}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EAEBF1"
        d="M77.704 11H65.207C64.54 11 64 11.54 64 12.207v1.69c0 .666.54 1.206 1.207 1.206h12.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM77.704 56H45.207C44.54 56 44 56.54 44 57.207v1.69c0 .666.54 1.206 1.207 1.206h32.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM24.704 48H2.207C1.54 48 1 48.54 1 49.207v1.69c0 .666.54 1.206 1.207 1.206h22.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207Z"
      />
      <g transform="translate(8 -.5)">
        <use
          xlinkHref="#VirtualCardAndBudget_svg__b"
          fill="#000"
          filter="url(#VirtualCardAndBudget_svg__a)"
        />
        <use xlinkHref="#VirtualCardAndBudget_svg__b" fill="#FFF" />
      </g>
      <g
        filter="url(#VirtualCardAndBudget_svg__c)"
        transform="rotate(20 20.166 36.612)"
      >
        <mask id="VirtualCardAndBudget_svg__e" fill="#fff">
          <use xlinkHref="#VirtualCardAndBudget_svg__d" />
        </mask>
        <use xlinkHref="#VirtualCardAndBudget_svg__d" fill="#EEFFFB" />
        <g mask="url(#VirtualCardAndBudget_svg__e)">
          <g transform="rotate(50 32.168 14.392)">
            <ellipse
              cx={34.241}
              cy={27.089}
              fill="#82DCC9"
              rx={26.949}
              ry={27.02}
            />
            <g transform="rotate(-16 64.532 7.913)">
              <use
                xlinkHref="#VirtualCardAndBudget_svg__g"
                fill="#000"
                filter="url(#VirtualCardAndBudget_svg__f)"
              />
              <use xlinkHref="#VirtualCardAndBudget_svg__g" fill="#FFF" />
            </g>
            <g strokeWidth={0.509}>
              <path stroke="#979797" d="m13.623 31.334 9.327 41.983" />
              <path
                stroke="#82DCC9"
                d="m13.623 31.334 9.327 41.983M13.623 31.334l9.327 41.983M15.452 29.563l9.327 41.982M17.282 27.792l9.327 41.982M19.112 26.02l9.326 41.983M20.94 24.25l9.328 41.982M22.77 22.478l9.327 41.982M24.6 20.707l9.326 41.983M26.43 18.937l9.326 41.981M28.258 17.165l9.327 41.982M30.088 15.394l9.326 41.982"
              />
            </g>
            <g strokeWidth={0.509}>
              <path stroke="#979797" d="m14.531 30.249 9.327 41.983" />
              <path
                stroke="#82DCC9"
                d="m14.531 30.249 9.327 41.983M14.531 30.249l9.327 41.983M16.36 28.478l9.327 41.982M18.19 26.707l9.327 41.982M20.02 24.935l9.326 41.983M21.849 23.165l9.327 41.982M23.678 21.393l9.327 41.982M25.507 19.622l9.327 41.983M27.337 17.852l9.327 41.981M29.166 16.08l9.327 41.982M30.996 14.309l9.326 41.982"
              />
            </g>
            <g transform="rotate(48 17.353 25.999)">
              <use
                xlinkHref="#VirtualCardAndBudget_svg__i"
                fill="#000"
                filter="url(#VirtualCardAndBudget_svg__h)"
              />
              <use xlinkHref="#VirtualCardAndBudget_svg__i" fill="#3BCAAA" />
            </g>
          </g>
        </g>
      </g>
      <g
        filter="url(#VirtualCardAndBudget_svg__j)"
        transform="rotate(-10 200.02 -140.95)"
      >
        <use
          xlinkHref="#VirtualCardAndBudget_svg__l"
          fill="#000"
          filter="url(#VirtualCardAndBudget_svg__k)"
        />
        <use xlinkHref="#VirtualCardAndBudget_svg__l" fill="#3475F2" />
        <path
          fill="#FFF"
          d="M19.02 15.59H4.023a.575.575 0 0 0-.575.574v.785c0 .318.258.575.575.575H19.02a.575.575 0 0 0 .574-.575v-.785a.575.575 0 0 0-.574-.574Z"
        />
        <path
          fill="#FFF"
          d="M10.872 3.804h-6.85a.575.575 0 0 0-.575.575v3.085c0 .317.258.574.575.574h6.85a.575.575 0 0 0 .575-.574V4.379a.575.575 0 0 0-.575-.575ZM46.425 3.804h-6.85a.575.575 0 0 0-.575.575v1.085c0 .317.257.574.575.574h6.85A.575.575 0 0 0 47 5.464V4.379a.575.575 0 0 0-.575-.575Z"
          opacity={0.75}
        />
        <path
          fill="#FFF"
          d="M38.493 21.28H4.022a.575.575 0 0 0-.575.574v.785c0 .317.258.575.575.575h34.47a.575.575 0 0 0 .575-.575v-.785a.575.575 0 0 0-.574-.575Z"
        />
        <path
          fill="url(#VirtualCardAndBudget_svg__m)"
          d="M4.022 26.969h6.613c.318 0 .575.257.575.575v.785a.575.575 0 0 1-.575.574H4.022a.575.575 0 0 1-.575-.574v-.785c0-.318.258-.575.575-.575Z"
          opacity={0.75}
          transform="matrix(-1 0 0 1 14.657 0)"
        />
        <path
          fill="url(#VirtualCardAndBudget_svg__m)"
          d="M24.13 26.969h6.614c.318 0 .575.257.575.575v.785a.575.575 0 0 1-.575.574h-6.613a.575.575 0 0 1-.575-.574v-.785c0-.318.257-.575.575-.575Z"
          opacity={0.75}
          transform="matrix(-1 0 0 1 54.875 0)"
        />
      </g>
    </g>
  </svg>
)
export default SvgVirtualCardAndBudget
